import { render, staticRenderFns } from "./CreateEmailDomain.vue?vue&type=template&id=7447dabc&"
import script from "./CreateEmailDomain.vue?vue&type=script&lang=js&"
export * from "./CreateEmailDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports